const TAG_SCORE = { "MEGA SMASH": 96, SMASH: 88, GOOD: 76, LEAN: 64, "LEAN OVER": 66, "LEAN UNDER": 62, "FADE/UNDER": 58, FADE: 56 };

function probability(row) {
  const values = [row.PWG_Prob_Over, row.PWG_Prob_Under, row["PWG Probability"], row.Probability, row.probability]
    .map(Number).filter(Number.isFinite).map((value) => value <= 1 ? value * 100 : value);
  return values.length ? Math.max(...values) : null;
}

export function calculatePwgScore(rows, fallback = 0) {
  const scores = (rows || []).map((row) => {
    const prob = probability(row);
    if (prob !== null) return Math.max(0, Math.min(100, prob));
    const tag = String(row.Tag ?? row.tag ?? "").toUpperCase();
    if (TAG_SCORE[tag] !== undefined) return TAG_SCORE[tag];
    const edge = Number(row.Edge ?? row.edge ?? row.DELTA ?? row["L10 Delta"]);
    return Number.isFinite(edge) ? Math.max(0, Math.min(100, 50 + edge * 2)) : null;
  }).filter(Number.isFinite);
  if (scores.length) return Math.max(...scores);
  const avg = Number(fallback);
  return Number.isFinite(avg) ? Math.max(0, Math.min(100, avg * 4)) : 0;
}

const POSITION_WEIGHT = { QB: 0.95, RB: 1, WR: 1, TE: 0.92, DST: 0.72 };

export function calculateDraftKingsBaseline(player, contestType) {
  const average = Math.max(0, Number(player.avgPoints) || 0);
  const salarySignal = Math.max(0, Number(player.salary) || 0) / 1000;
  const position = player.position === "CPT" ? "FLEX" : player.position;
  const positionWeight = POSITION_WEIGHT[position] || 0.9;
  const contestWeight = contestType === "SHOWDOWN" ? 0.98 : 1;
  return Math.max(0, Math.min(100, ((average * 3.2) + (salarySignal * 2.4 * positionWeight)) * contestWeight));
}

export const PWG_SCORE_DESCRIPTION = "Projected quality is a 0–100 optimization score. PWG-enriched records use the strongest loaded PWG probability, then the existing PWG tag tier, then 50 + 2× edge/delta. DraftKings-only and ambiguous records receive no PWG intelligence; their labeled baseline is 3.2× DraftKings AvgPointsPerGame plus 2.4× salary-in-thousands adjusted by position and contest context. This does not alter NFL analysis.";
